import { render, staticRenderFns } from "./SceneSettingDialog.vue?vue&type=template&id=15964764&"
import script from "./SceneSettingDialog.vue?vue&type=script&lang=js&"
export * from "./SceneSettingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports